import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomEmptyResultaat implements IBaseVraagboomResultaat {
  constructor() {
  }
}
